import React from 'react';
import Box from './box';

const SuccessBox = props => <Box className="alert-success" alignment={props.alignment}>
  {props.children}
</Box>;
export default SuccessBox;
